export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_SIDEBAR = 'SET_SIDEBAR';

export const toggleSideBar = () => ({ type: TOGGLE_SIDEBAR });
export const setSideBarOpen = (isOpen) => ({ type: SET_SIDEBAR, isOpen });
